module.exports = __webpack_public_path__ + "chefy-maestro.png?600d5dfb1c26a9d3b5a890cb96d55e66";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-maestro.png
// module id = 40
// module chunks = 0